import React, { useEffect, useState } from "react";
import LoginNavbar from "./LoginNavbar";
import LoginPage from "./LoginPage";
import { useHistory } from "react-router-dom";

export default function Login() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (itemStr) {
      history.push("/");
    }
    else{
      setLoading(false)
    }

    document.title = "VisaPro | Login";
  }, []);

  return (
    <div>
      {loading ? (
        <div style={{ height: "100vh", width: "100%", backgroundColor: "transparent"}}>
          
        </div>
      ):
      (
      <div>
        <LoginNavbar />
        <LoginPage />
      </div>
      )}
    </div>
  );
}
